import { PARTNERS_SEGMENT_PAGE } from "@/data/marketing/segmentPages";
import SegmentLandingPage from "./SegmentLandingPage";

const HelpGenieForPartnersPage = () => {
  return <SegmentLandingPage content={PARTNERS_SEGMENT_PAGE} />;
};

export default HelpGenieForPartnersPage;
